import './Landing.css';

function Landing({ onGetStarted, onLogin }) {
    return (
        <div className="landing">
            <div className="landing-header">
                <img src="/logo192.png" alt="ThePinBook" className="landing-logo" />
                <span className="landing-wordmark">ThePinBook</span>
            </div>

            <div className="landing-hero">
                <h1>Turn dopamine into meaning</h1>
                <p className="landing-hero-subhead">ThePinBook helps you extract wisdom <br />from everything the algorithm knows you want to know.</p>
                <p>It's Pinterest meets NotebookLM. <br />Save social media videos and posts, organize them into chapters, <br />then ask AI questions about what you saved.</p>
            </div>

            <div className="landing-demo">
                <div className="landing-demo-card">
                    <div className="landing-demo-label">EMAIL</div>
                    <div className="landing-demo-row"><span>To:</span> curious@reply.thepinbook.com</div>
                    <div className="landing-demo-row"><span>Subject:</span> Fun Stuff in NYC</div>
                    <div className="landing-demo-body">https://www.facebook.com/share/r/1B5miYmpd5/&hellip;</div>
                </div>

                <div className="landing-demo-arrow">&rarr;</div>

                <div className="landing-demo-card">
                    <div className="landing-demo-label landing-demo-label-chapter">NEW PIN</div>
                    <div className="landing-demo-check">Fun Stuff in NYC</div>
                    <div className="landing-demo-check">&#10003; Transcribed</div>
                    <div className="landing-demo-check">&#10003; Ready to ask AI</div>
                    <div className="landing-demo-body">&ldquo;Give me the addresses of 3 rooftop restaurants in Midtown NYC.&rdquo;</div>
                </div>
            </div>

            <div className="landing-methods">
                <div className="landing-methods-eyebrow">Two ways to pin something</div>
                <div className="landing-methods-grid">
                    <div className="landing-method">
                        <div className="landing-method-number">1</div>
                        <div className="landing-method-title">Paste a link here</div>
                        <div className="landing-method-desc">Drop a URL into your dashboard while you're already here.</div>
                    </div>
                    <div className="landing-method">
                        <div className="landing-method-number">2</div>
                        <div className="landing-method-title">Email a link and chapter title</div>
                        <div className="landing-method-desc">Send to your custom PinBook email address.<br />The subject becomes the chapter title.</div>
                    </div>
                </div>
            </div>

            <div className="landing-cta">
                <button className="landing-btn-primary" onClick={onGetStarted}>Get started</button>
                <button className="landing-btn-secondary" onClick={onLogin}>Log in</button>
            </div>
        </div>
    );
}

export default Landing;
